import React, { useEffect } from "react";
import { Person } from "../../domain/Person";
import { useSelector, useDispatch } from "react-redux";
import { getPersonsWithMeetings } from "../../store/ReceptionStore";
import config from "../../config.json";

interface Props {
    changeStepClick: (stepName: string) => void;
    changeGreeterClick: (person: Person) => void;
    notifyAction: (person?: Person) => void;
}

const SelectHostStep: React.FC<Props> = ({ changeStepClick, changeGreeterClick, notifyAction }) => {
    const dispatch = useDispatch();
    const receptionState = useSelector((state: any) => state.receptionState);

    useEffect(() => {
        dispatch(getPersonsWithMeetings() as any);
    }, [dispatch]);

    if (!receptionState.hosts) return <div>Waiting...</div>;

    const personClick = (p: Person) => {
        changeGreeterClick(p);
        notifyAction(p);
        changeStepClick("documents");
    };

    return (
        <>
            <h1>Hvem har du en aftale med?</h1>
            <div className='greeter-list'>
                {/*
                <div className={'host-person'} onClick={() => personClick(receptionState.settings.visitorHandler)}>
                    <img src={`${config.server}${receptionState.settings.visitorHandler.imagePath}`} alt={receptionState.settings.visitorHandler.name} />
                    <div className='host-name'>Ved ikke/anden</div>
                </div>
                */}
                {receptionState.hosts.map((x: Person) => (
                    <div className={'host-person'} key={x.id} onClick={() => personClick(x)}>
                        {x.imagePath && <img src={`${config.server}${x.imagePath}`} alt={x.name} />}
                        <div className='host-name'>{x.name}</div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default SelectHostStep;